import React from 'react';
import cx from 'classnames';

import { Dropdown, Text, Switch } from '../../../../../../ui-kit';

import '../../styles/_setting-section.scss';











function SettingSection(props) {
  const {
    title,
    subtitle,
    onChange,
    defaultValue,
    options,
    isSwitch,
    children
  } = props;

  return (
    <div className="setting-section">
      <div className={cx(
        'setting-section__content', {
          'setting-section--with-children': Boolean(children)
        })}>

        <div>
          <Text className="setting-section__title" highlighted>
            {title}
          </Text>
          {subtitle &&
          <span className="setting-section__subtitle">
              {subtitle}
            </span>}

        </div>
        {!isSwitch ?
        <Dropdown
          className="setting-section__drop-down"
          type="BASIC"
          onChange={onChange}
          defaultValue={defaultValue}
          options={options} /> :


        <Switch
          onChange={onChange}
          checked={Boolean(defaultValue)} />}


      </div>
      {children}
    </div>);

}

SettingSection.defaultProps = {
  options: []
};

export default SettingSection;